var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mds-list-group-item',{attrs:{"text":_vm.titleText,"active":_vm.$route.path == _vm.routeString,"to":_vm.routeString}})
}
var staticRenderFns = []

export { render, staticRenderFns }